<template>
  <div>
    <b-container fluid class="page-header py-5 mb-5 text-center">
      <b-container class="py-5">
        <h1 class="display-3 text-white mb-3 animated slideInDown">Products</h1>

        <b-breadcrumb class="animated slideInDown justify-content-center" :items="breadcrumbItems" aria-label="breadcrumb">
          <template #item="{ item }">
            <span :class="['breadcrumb-item', item.active ? 'active text-white' : 'text-white']">
              <router-link v-if="item.to" :to="item.to" class="text-white">{{ item.text }}</router-link>
              <span v-else>{{ item.text }}</span>
            </span>
          </template>
        </b-breadcrumb>
      </b-container>
    </b-container>
    <b-container class="pb-5">
      <div class="text-center mx-auto mb-5" style="max-width: 600px;">
        <h2 class="section-title">Our Products</h2>
        <div class="title-underline mx-auto"></div>
      </div>

      <b-row>
        <b-col v-for="(product, index) in products" :key="index" md="4" class="mb-4">
          <div class="product-item">
            <div class="product-img-container p-4">
              <b-img :src="product.image" :alt="product.name" fluid class="mx-auto d-block"></b-img>
            </div>
            <div class="product-label p-3 text-center">
              <h5 class="m-0">{{ product.name }}</h5>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    </div>
</template>

<script>
export default {
  name: "ProductsPage",
  data() {
    return {
      breadcrumbItems: [
        { text: 'Home', to: '/' },
        { text: 'Products', to: '/products' }
      ],
      products: [
        { name: 'Box IP Camera', image: require('../assets/camera.jpg') },
        { name: 'Bullet IP Camera', image: require('../assets/product-1.png') },
        { name: 'Eyeball IP Camera', image: require('../assets/product-2.png') },
        { name: 'Dome IP Camera', image: require('../assets/product-3.png') },
        { name: 'Bullet IP Camera', image: require('../assets/product-4.png') },
        { name: 'Wifi IP Camera', image: require('../assets/camera.jpg') },
        { name: 'Wifi IP Camera', image: require('../assets/camera.jpg') }
      ]
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(rgba(22, 22, 22, 0.7), rgba(22, 22, 22, 0.7)),
  url('@/assets/carousel_1.jpg') center center no-repeat;
  background-size: cover;
  font-family: 'Poppins', sans-serif;
}

.breadcrumb-item, h1 {
  font-family: 'Poppins', sans-serif;
}

.breadcrumb-item .router-link-active,
.breadcrumb-item .router-link-exact-active,
.breadcrumb-item a {
  color: white !important;
  text-decoration: none;
}

.breadcrumb { background-color: transparent !important; padding: 0; margin: 0; }

/* Product Section Styling */
.section-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  color: #1a202e;
  margin-bottom: 5px;
}

.title-underline {
  width: 50px;
  height: 3px;
  background-color: #dc3545; /* Red accent color */
  border-radius: 2px;
}

.product-item {
  background: #ffffff;
  transition: .5s;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
}

.product-item:hover {
  box-shadow: 0 0 30px #990000;
  transform: translateY(-5px);
}

.product-img-container {
  background: #fcfcfc;
  min-height: 220px;
  display: flex;
  align-items: center;
}

.product-label {
  background: #ffffff;
}

.product-label h5 {
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}
</style>